import React, { Component } from 'react'
import axios from 'axios'
import Select from 'react-select'
import CheckboxTree from 'react-checkbox-tree';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import appSettings from '../assets/app-settings.json';

export class RequestProfiles extends Component {

    state = {
        sites: [],
        selectedSite: null,
        groupedLayers: [],
        checked: [],
        expanded: [],
        selectedDatasets: {}
    }

    componentDidMount() {
        this.fetchProfileDatasets();
    }

    // restoreSelectedSite = (isForceUpdate) => {
    //     const siteString = localStorage.getItem("profileSelectedSite");
    //     if (siteString) {
    //         const site = JSON.parse(siteString);
    //         this.setState({
    //             selectedSite: site
    //         }, () => {
    //             this.handleSiteSelect(site);
    //         });
    //     }
    // }

    restoreSelectedDatasets = () => {
        const siteString = localStorage.getItem("profileSelectedSite");
        let savedSite = undefined;
        if (siteString) {
            savedSite = JSON.parse(siteString);
            // this.setState({
            //     selectedSite: site
            // }, () => {
            //     this.handleSiteSelect(site);
            // });
        }

        const datasetsString = localStorage.getItem("profileDatasetsSelected");
        if (datasetsString) {
            const datasets = JSON.parse(datasetsString);

            let checked = [];
            if (savedSite) {
                checked = datasets[savedSite.name];
            }

            let site = undefined;
            if (this.state.sites) {
                site = this.state.sites.find(s => s.name === savedSite.name);
            }

            this.setState({
                checked: checked,
                selectedDatasets: datasets,
                selectedSite: site
            }, () => {
                if (site) {
                    this.handleSiteSelect(site);
                }
            });
        }
    }

    fetchProfileDatasets = () => {
        this.setIsBusyStatus(true);
        const appSettings = window.AppConfigSettings;
        const url = appSettings.baseApiUrl + "/downloads/profileDatasets";
        axios.get(url)
            .then(res => {
                const datasets = res.data;
                const sites = datasets.map(site => {
                    return { id: site.id, name: site.name, description: site.description, value: site.name, label: site.description, surveys: site.surveys };
                }).filter(s => !appSettings.ExcludedSites.includes(s.name));
                this.setState({
                    sites: sites
                }, () => {
                    this.restoreSelectedDatasets();
                    localStorage.setItem("profileDatasets", JSON.stringify(sites));
                });
                // console.log("[sites]", sites);
            })
            .finally(()=>{
                this.setIsBusyStatus(false);
            });
    }


    handleSiteSelect = (site) => {
        if (site.id === 0) {
            this.setState({
                selectedSite: site
            });
            return;
        }
        console.log("[site]", site);
        let checkedItems = [];
        if (site) {
            checkedItems = this.state.selectedDatasets[site.name];
        }
        this.setState({
            selectedSite: site,
            checked: checkedItems
        });
        localStorage.setItem("profileSelectedSite", JSON.stringify({ id: site.id, name: site.name }));


        const data = site.surveys.map(s => {
            const item = {
                value: s.id,
                label: s.name,
                children: s.transects.map(t => {
                    const childItem = {
                        value: site.id + '_' + s.id + '_' + t.id,
                        label: t.name,
                    }
                    return childItem;
                })
            }
            return item;
        });

        this.setState({
            groupedLayers: data
        });
    }

    onCheck = (checked) => {
        const selectedDatasets = { ...this.state.selectedDatasets };
        if (this.state.selectedSite) {
            selectedDatasets[this.state.selectedSite.name] = checked;
        }
        this.setState({
            checked: checked,
            selectedDatasets: selectedDatasets
        });
        console.log("[checked]", checked);
        // console.log("[selectedDatasets]", selectedDatasets);

        localStorage.setItem("profileDatasetsSelected", JSON.stringify(selectedDatasets));
    }

    onExpand = (expanded) => {
        this.setState({ expanded: expanded });
    }

    setIsBusyStatus = (isBusy) => {
        if (this.props.isBusyChange) {
            this.props.isBusyChange(isBusy);
        }
    }

    render() {
        return (
            <div>
                <Select
                    className="sites-select"
                    options={this.state.sites}
                    onChange={this.handleSiteSelect}
                    value={this.state.selectedSite}
                    placeholder="Select beach site..."
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 3,
                        colors: {
                            ...theme.colors,
                            primary: '#3396c7',
                            primary25: '#3396c728',
                        },
                    })}
                />
                <div className="treeview-container">
                    <CheckboxTree
                        checked={this.state.checked}
                        expanded={this.state.expanded}
                        iconsClass="fa5"
                        nodes={this.state.groupedLayers}
                        onCheck={this.onCheck}
                        onExpand={this.onExpand}
                        icons={{
                            check: <FontAwesomeIcon className="rct-icon rct-icon-check" icon="check-square" />
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default RequestProfiles
